export default "/build/frontend/fonts/vendor/@fontsource/inter/files/inter-cyrillic-400-normal.woff2?cb04b2ee2f7d192478b8636fc502aae5";